// extracted by mini-css-extract-plugin
export default {"root":"SecondaryLayout_root__J7V8b","backButton":"SecondaryLayout_backButton__oKOWA"};